import TextInput from "Components/molecule/inputs/text-input"
import { ChangeEvent } from "react"
import ConsultantFields from "./types"
import SelectInput, { SelectOption } from "Components/molecule/inputs/select-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormProps from "data/forms"
import SecondaryButton from "Components/atoms/buttons/secondary-button"

interface ConsultantFormProps extends FormProps<ConsultantFields> {
    genders: SelectOption[]
    jobTitles: SelectOption[]
    managers: SelectOption[]
    departments: SelectOption[]
    officeLocations: SelectOption[]
    status: SelectOption[]
    employeeTypes: SelectOption[]
    potentialConsultant: boolean
    disabledFields?: Partial<Record<keyof ConsultantFields, boolean>>
}

const FIRST_NAME_KEY = 'firstName'
const MIDDLE_NAME_KEY = 'middleName'
const LAST_NAME_KEY = 'lastName'
const COMMON_NAME_KEY = 'commonName'
const EMPLOYEE_CODE_KEY = 'employeeCode'
const GENDER_KEY = 'genderId'
const COMPANY_EMAIL_KEY = 'companyEmail'
const PHONE_NUMBER_KEY = 'phoneNumber'
const JOB_TITLE_KEY = 'jobTitleId'
const MANAGER_KEY = 'managerId'
const DEPARTMENT_KEY = 'departmentId'
const OFFICE_LOCATION_KEY = 'officeLocationId'
const STATUS_KEY = 'statusId'
const HIRE_DATE_KEY = 'hireDate'
const TERMINATION_DATE_KEY = 'terminationDate'
const CONTRACT_END_DATE_KEY = 'contractEndDate'
const EMPLOYEE_TYPE_KEY = 'employeeTypeId'

const ConsultantForm = ({
    handleChange,
    handleCancel,
    handleSubmit,
    handleBlur,
    values,
    genders,
    jobTitles,
    managers,
    departments,
    officeLocations,
    status,
    employeeTypes,
    isSubmitting,
    errors,
    isValid,
    touched,
    edit,
    potentialConsultant,
    disabledFields
}: ConsultantFormProps) => {

    return <div className="form-container">
        <div className="input-grid">
            <SelectInput
                touched={!!touched.employeeTypeId}
                name={EMPLOYEE_TYPE_KEY}
                key={EMPLOYEE_TYPE_KEY}
                label={"Employee Type*"}
                placeholder={"Select Empoyee Type"}
                options={employeeTypes}
                value={values.employeeTypeId || ''}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.employeeTypeId && !!errors.employeeTypeId}
                message={touched.employeeTypeId ? errors.employeeTypeId : undefined}
                disabled={disabledFields?.employeeTypeId}
            />
            <TextInput
                touched={!!touched.firstName}
                name={FIRST_NAME_KEY}
                key={FIRST_NAME_KEY}
                label={"First Name*"}
                placeholder={"First Name"}
                value={values.firstName}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.firstName && !!errors.firstName}
                message={touched.firstName ? errors.firstName : undefined}
                disabled={disabledFields?.firstName}
            />
            <TextInput
                touched={!!touched.middleName}
                name={MIDDLE_NAME_KEY}
                key={MIDDLE_NAME_KEY}
                label={"Middle Name"}
                placeholder={"Middle Name"}
                value={values.middleName || ''}
                onChange={handleChange}
                onBlur={handleBlur}

                error={!!touched.middleName && !!errors.middleName}
                message={touched.middleName ? errors.middleName : undefined}
                disabled={disabledFields?.middleName}
            />
            <TextInput
                touched={!!touched.lastName}

                name={LAST_NAME_KEY}
                key={LAST_NAME_KEY}
                label={"Last Name*"}
                placeholder={"Last Name"}
                value={values.lastName}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.lastName && !!errors.lastName}
                message={touched.lastName ? errors.lastName : undefined}
                disabled={disabledFields?.lastName}
            />
            <TextInput
                touched={!!touched.commonName}
                name={COMMON_NAME_KEY}
                key={COMMON_NAME_KEY}
                label={"Preferred Name"}
                placeholder={"Preferred Name"}
                value={values.commonName || ''}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.commonName && !!errors.commonName}
                message={touched.commonName ? errors.commonName : undefined}
                disabled={disabledFields?.commonName}
            />
            <TextInput
                touched={!!touched.employeeCode}
                name={EMPLOYEE_CODE_KEY}
                key={EMPLOYEE_CODE_KEY}
                label={"Code*"}
                placeholder={"Employee Code"}
                value={values.employeeCode}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.employeeCode && !!errors.employeeCode}
                message={touched.employeeCode ? errors.employeeCode : undefined}
                disabled={disabledFields?.employeeCode}
            />
            {!potentialConsultant &&
                <>
                    <SelectInput
                        touched={!!touched.genderId}
                        name={GENDER_KEY}
                        key={GENDER_KEY}
                        label={"Gender*"}
                        placeholder={"Select Gender"}
                        options={genders}
                        value={values.genderId || ''}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.genderId && !!errors.genderId}
                        message={touched.genderId ? errors.genderId : undefined}
                        disabled={disabledFields?.genderId}
                    />
                    <TextInput
                        touched={!!touched.companyEmail}
                        name={COMPANY_EMAIL_KEY}
                        key={COMPANY_EMAIL_KEY}
                        label={"Company Email*"}
                        placeholder={"email@company.com"}
                        value={values.companyEmail || ''}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.companyEmail && !!errors.companyEmail}
                        message={touched.companyEmail ? errors.companyEmail : undefined}
                        disabled={disabledFields?.companyEmail}
                    />
                    <TextInput
                        touched={!!touched.phoneNumber}
                        name={PHONE_NUMBER_KEY}
                        key={PHONE_NUMBER_KEY}
                        label={"Phone Number"}
                        placeholder={"Phone Number"}
                        value={values.phoneNumber || ''}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.phoneNumber && !!errors.phoneNumber}
                        message={touched.phoneNumber ? errors.phoneNumber : undefined}
                        disabled={disabledFields?.phoneNumber}
                    />
                    <SelectInput
                        touched={!!touched.jobTitleId}
                        name={JOB_TITLE_KEY}
                        key={JOB_TITLE_KEY}
                        label={"Job Title*"}
                        placeholder={"Select Job Title"}
                        options={jobTitles}
                        value={values.jobTitleId || ''}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.jobTitleId && !!errors.jobTitleId}
                        message={touched.jobTitleId ? errors.jobTitleId : undefined}
                        disabled={disabledFields?.jobTitleId}
                    />

                    <SelectInput
                        touched={!!touched.managerId}
                        name={MANAGER_KEY}
                        key={MANAGER_KEY}
                        label={"Manager*"}
                        placeholder={"Select Manager"}
                        options={managers}
                        value={values.managerId || ''}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.managerId && !!errors.managerId}
                        message={touched.managerId ? errors.managerId : undefined}
                        disabled={disabledFields?.managerId}
                    />

                    <SelectInput
                        touched={!!touched.departmentId}
                        name={DEPARTMENT_KEY}
                        key={DEPARTMENT_KEY}
                        label={"Department*"}
                        placeholder={"Select Department"}
                        options={departments}
                        value={values.departmentId || ''}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.departmentId && !!errors.departmentId}
                        message={touched.departmentId ? errors.departmentId : undefined}
                        disabled={disabledFields?.departmentId}
                    />
                    <SelectInput
                        touched={!!touched.officeLocationId}
                        name={OFFICE_LOCATION_KEY}
                        key={OFFICE_LOCATION_KEY}
                        label={"Office Location*"}
                        placeholder={"Select Office Location"}
                        options={officeLocations}
                        value={values.officeLocationId || ''}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.officeLocationId && !!errors.officeLocationId}
                        message={touched.officeLocationId ? errors.officeLocationId : undefined}
                        disabled={disabledFields?.officeLocationId}
                    />
                    <TextInput
                        touched={!!touched.hireDate}
                        name={HIRE_DATE_KEY}
                        key={HIRE_DATE_KEY}
                        label={"Hire Date*"}
                        placeholder={"YYYY-MM-DD"}
                        type="date"
                        value={values.hireDate ? values.hireDate.split('T')[0] : ''}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.hireDate && !!errors.hireDate}
                        message={touched.hireDate ? errors.hireDate : undefined}
                        disabled={disabledFields?.hireDate}
                    />
                    <TextInput
                        touched={!!touched.contractEndDate}
                        name={CONTRACT_END_DATE_KEY}
                        key={CONTRACT_END_DATE_KEY}
                        label={"Contract End Date"}
                        placeholder={"YYYY-MM-DD"}
                        type="date"
                        value={values.contractEndDate ? values.contractEndDate.split('T')[0] : ''}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.contractEndDate && !!errors.contractEndDate}
                        message={touched.contractEndDate ? errors.contractEndDate : undefined}
                        disabled={disabledFields?.contractEndDate}
                    />
                    {edit &&
                        <>
                            <SelectInput
                                touched={!!touched.statusId}
                                name={STATUS_KEY}
                                key={STATUS_KEY}
                                label={"Status"}
                                placeholder={"Select Status"}
                                options={status}
                                value={values.statusId || ''}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                error={!!touched.statusId && !!errors.statusId}
                                message={touched.statusId ? errors.statusId : undefined}
                                disabled={disabledFields?.statusId}
                            />
                            <TextInput
                                touched={!!touched.terminationDate}
                                name={TERMINATION_DATE_KEY}
                                key={TERMINATION_DATE_KEY}
                                label={"Termination Date"}
                                placeholder={"YYYY-MM-DD"}
                                type="date"
                                value={values.terminationDate ? values.terminationDate.split('T')[0] : ''}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                error={!!touched.terminationDate && !!errors.terminationDate}
                                message={touched.terminationDate ? errors.terminationDate : undefined}
                                disabled={disabledFields?.terminationDate}
                            />
                        </>
                    }
                </>}
        </div>
        <div className="button-container">
            <PrimaryButton
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
            >
                {isSubmitting ? "Saving...." : "Save"}
            </PrimaryButton>
            {
                handleCancel &&
                <SecondaryButton
                    disabled={isSubmitting}
                    onClick={() => handleCancel()}
                >
                    Back
                </SecondaryButton>
            }
        </div>
    </div>
}

export default ConsultantForm